import { ManageCaregiversSection } from "@/features/patient/family/components/ManageCaregiversView";
import { useFamily } from "@/portals/patient/context/FamilyContext";
import { PageSpinner } from "@/shared/components/spinner";

export function ManageCaregiversPage() {
  const { caregivers, isLoading, error, refresh } = useFamily();

  if (isLoading) return <PageSpinner />;
  if (error) return <div className="py-24 text-center text-sm font-semibold text-[#E4002B]">{error}</div>;

  return <ManageCaregiversSection caregivers={caregivers} onChange={refresh} />;
}
